import React, {useContext, useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
// Form related
import { Field } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import { UserContext } from "../../../Models/UserContext";
import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

export default function CUF(props) {
    const user = useContext(UserContext);
    const [newTotal, setNewTotal] = useState(0);
    const [upgradeTotal, setUpgradeTotal] = useState(0);
    const [planTerm, setPlanTerm] = useState(0);
    const classes = useStyles();
    const {formField, values, serviceData} = props;
    console.log(serviceData);

    useEffect(() => {
        let newTtl = 0;
        let upgradeTtl = 0;

        for( let i = 0; i < serviceData.length; i++ ) {
            switch (serviceData[i].new_connection_type) {
                case 'New':
                case 'Port':
                    newTtl += 1;
                    break;
                case 'Upgrade/Resign':
                    upgradeTtl += 1;
                    break;
            }
        }

        setNewTotal(newTtl);
        setUpgradeTotal(upgradeTtl);

        if( serviceData.length > 0 ) {
            setPlanTerm(serviceData[0].plan_term);
        }
    }, []);

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Customer Understanding Form</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <GridContainer>
                                        <GridItem xs={12} md={6}>
                                            <Field
                                                component={CustomInput}
                                                labelText="Legal Entity Name"
                                                name={formField.company_name.name}
                                                id={formField.company_name.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: values[formField.company_name.name]
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText="Sales Rep"
                                                name="representative_name"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: user.data.first_name + " " + user.data.last_name
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <Field
                                                component={DatePicker}
                                                format="DD/MM/yyyy"
                                                name={formField.representative_signature_date.name}
                                                id={formField.representative_signature_date.name}
                                                label={formField.representative_signature_date.label}
                                                className={classes.itemSpacer + " " + classes.underline}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText="Dealer Code"
                                                name="dealer_code"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: user.data.dealer_code
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem xs={12}>
                                    <h4 className={classes.sectionHeader}>Summary of Agreement</h4>
                                    <GridContainer>
                                        <GridItem sm={6} md={3}>
                                            <Field
                                                component={CustomInput}
                                                labelText="Total No. of Services"
                                                name="total_services"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: serviceData.length
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem sm={6} md={3}>
                                            <Field
                                                component={CustomInput}
                                                labelText="Upgrade"
                                                name="total_upgrade"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: upgradeTotal
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem sm={6} md={3}>
                                            <Field
                                                component={CustomInput}
                                                labelText="New"
                                                name="total_new"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: newTotal
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem sm={6} md={3}>
                                            <Field
                                                component={CustomInput}
                                                labelText="Contract Length"
                                                name="contract_length"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: planTerm
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={4}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.hardware_allowance.label}
                                                name={formField.hardware_allowance.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    type: "number",
                                                    startAdornment:<InputAdornment position="start">$</InputAdornment>
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={8}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.hardware_ordered.label}
                                                name={formField.hardware_ordered.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Field
                                                component={CustomInput}
                                                labelText="Delivery Address"
                                                name="delivery_address"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true,
                                                    value: values[formField.current_trading_address.fields.street.name]+', '+values[formField.current_trading_address.fields.state.name]+', '+values[formField.current_trading_address.fields.postcode.name]
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={6}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.data_allowance.label}
                                                name={formField.data_allowance.name}
                                                id={formField.data_allowance.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    type: "number",
                                                    endAdornment:<InputAdornment position="end">GB</InputAdornment>
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={6}>
                                            <label>{formField.international_calling_allowance.label}</label>
                                            <GridContainer>
                                                <GridItem xs={6}>
                                                    <Field
                                                        component={CustomInput}
                                                        labelText={formField.international_calling_allowance.fields.zone_1.label}
                                                        name={formField.international_calling_allowance.fields.zone_1.name}
                                                        id={formField.international_calling_allowance.fields.zone_1.name}
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            type: "number",
                                                            endAdornment:<InputAdornment position="end">mins</InputAdornment>
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={6}>
                                                    <Field
                                                        component={CustomInput}
                                                        labelText={formField.international_calling_allowance.fields.zone_2.label}
                                                        name={formField.international_calling_allowance.fields.zone_2.name}
                                                        id={formField.international_calling_allowance.fields.zone_2.name}
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            type: "number",
                                                            endAdornment:<InputAdornment position="end">mins</InputAdornment>
                                                        }}
                                                    />
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.minimum_monthly_commitment.label}
                                                name={formField.minimum_monthly_commitment.name}
                                                id={formField.minimum_monthly_commitment.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    startAdornment:<InputAdornment position="start">$</InputAdornment>,
                                                    endAdornment:<InputAdornment position="end">inc GST</InputAdornment>
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem xs={12}>
                                    <h4 className={classes.sectionHeader}>Payout Agreement</h4>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            <div>Vodafone Business Centre Port Melbourne have agreed to provide you with the funds to payout your current mobile contract up to the amount of</div>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Field
                                                component={CustomInput}
                                                name={formField.payout_amount.name}
                                                id={formField.payout_amount.name}
                                                formControlProps={{
                                                    fullWidth: false
                                                }}
                                                inputProps={{
                                                    type: "number",
                                                    startAdornment:<InputAdornment position="start">$</InputAdornment>
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <h4 className={classes.sectionHeader}>Non-Standard Offer</h4>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Field
                                                component={CustomInput}
                                                name={formField.non_standard_offer.name}
                                                id={formField.non_standard_offer.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    multiline: true,
                                                    rows: 4
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <div>
                                                Any payments mentioned above will be made after your 4<sup>th</sup> billing cycle with Vodafone. Please email your final bill to <a href="mailto:info@vbcportmelbourne.com.au">info@vbcportmelbourne.com.au</a>
                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.cuf_approved_by.label}
                                                name={formField.cuf_approved_by.name}
                                                id={formField.cuf_approved_by.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.cuf_approve_signed.label}
                                                name={formField.cuf_approve_signed.name}
                                                id={formField.cuf_approve_signed.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                            <Field
                                                component={DatePicker}
                                                format="DD/MM/yyyy"
                                                name={formField.cuf_approve_date.name}
                                                id={formField.cuf_approve_date.name}
                                                label={formField.cuf_approve_date.label}
                                                className={classes.itemSpacer + " " + classes.underline}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <Divider className={classes.divider} />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <div>
                                                I,&nbsp;&nbsp;&nbsp;
                                                <Field
                                                    component={CustomInput}
                                                    name="customer_name"
                                                    formControlProps={{
                                                        fullWidth: false
                                                    }}
                                                    inputProps={{
                                                        readOnly: true,
                                                        value: values.given_name + " " + values.surname
                                                    }}
                                                />
                                                &nbsp;&nbsp;(Customer's Full Name), understand what I have read and signed on this form. I understand
                                                that I will receive only what is represented on this form. Any information regarding any other arrangements not noted on this form will not
                                                be held with any validity and may not be honoured by VBC Port Melbourne.
                                            </div>
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <Field
                                                component={CustomInput}
                                                labelText="(Customer Signature)"
                                                name="customer_signature"
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <Field
                                                component={CustomInput}
                                                labelText="(Sales Rep Signature)"
                                                name={formField.representative_signature.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <Field
                                                component={CustomInput}
                                                labelText="(Position)"
                                                name={formField.position_in_company.name}
                                                id={formField.position_in_company.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} md={6}>
                                            <GridItem xs={12} sm={6}>
                                                <Field
                                                    component={DatePicker}
                                                    format="DD/MM/yyyy"
                                                    name={formField.customer_signature_date.name}
                                                    id={formField.customer_signature_date.name}
                                                    label={formField.customer_signature_date.label}
                                                    className={classes.itemSpacer + " " + classes.underline}
                                                />
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
